/*
 * @Author: siqiang
 * @Date: 2019-03-22 10:42:54
 * @Last Modified by: zone Tian
 * @Last Modified time: 2020-06-11 18:03:46
 * @Function 视屏组件封装
 */
import React from 'react';
import PropTypes from 'prop-types';

class MyVideo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isPlay: false
    }
  }
  playMyVideo() {
    let oMyVideo = this.refs.myVideo;
    oMyVideo.play();
  }
  pause(){
    this.setState({ isPlay: false });
  }
  play(){
    this.setState({ isPlay: true });
  }
  render() {
    const { 
            src,
            width,
            height,
            icon = '',
            poster = '',
            wrapper = '',
            controls = true,
            type = 'video/mp4', 
          } = this.props,
          { isPlay } = this.state,
          icon_style = isPlay ? { display: 'none' } : { display: 'block' };
          
    return (
      <div className={ wrapper }>
        <video ref='myVideo' src={ src } poster={ poster } width={ width } height={ height } controls={ controls } onPause={ this.pause.bind( this ) } onPlay={ this.play.bind( this ) } style={{objectFit: 'fill'}} >
          您的浏览器不支持video,请更换浏览器播放。
        </video>
        <i className={ icon } style={ icon_style } onClick={ this.playMyVideo.bind( this ) }></i>
      </div>
    )
  }
}

MyVideo.propTypes = {
  // 视频地址
  src: PropTypes.string.isRequired,
  // 视频类型
  type: PropTypes.string,
  // 封面
  poster: PropTypes.string,
  // 视频的宽度
  width: PropTypes.string,
  // 视频的高度
  height: PropTypes.string,
}
export default MyVideo



// WEBPACK FOOTER //
// ./common/components/molecules/Video/index.js